const PregnancyCheckbox = ({ checked, onChange }) => {
  return (
    <div className="mb-4 p-3 rounded" style={{ background: "#f8f9fa" }}>
      <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
        Situation particulière
      </label>
      <div className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          id="pregnancy"
          checked={checked}
          onChange={onChange}
        />
        <label className="custom-control-label" htmlFor="pregnancy">
          L'allocataire est enceinte
        </label>
      </div>
      <p
        className="text-muted mt-2 mb-0"
        style={{ fontSize: 13, fontStyle: "italic" }}
      >
        Cette information peut modifier les propositions de barème
      </p>
    </div>
  );
};

export default PregnancyCheckbox;
